"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xas(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.494 10.8532L12.3923 19.1108L12.0735 19.5L4.50525 10.9365L4.52925 10.9268L4.5 10.9222L7.4415 6.0045L7.443 6.006L7.4415 6H16.632L16.6305 6.00525L19.5 10.8525L19.494 10.8532ZM9.642 11.1975L8.0145 13.953L12.0285 18.537L16.0507 13.9155L14.4592 11.1892L9.642 11.1975ZM7.5585 13.4325L8.8785 11.1982L5.607 11.2035L7.5585 13.4325ZM14.8507 10.548L18.5662 10.542L16.2338 6.636L12.5723 6.6435L14.8507 10.548ZM18.429 11.1825L15.2242 11.1877L16.509 13.389L18.429 11.1825ZM14.0858 10.5495L12.0675 7.0905L10.02 10.5555L14.0858 10.5495ZM7.7865 6.654L5.4615 10.5638L9.2565 10.557L11.5665 6.6465L7.7865 6.654Z", fill: color }),
        React.createElement("path", { d: "M19.494 10.1032L12.3923 18.3608L12.0735 18.75L4.50525 10.1865L4.52925 10.1768L4.5 10.1722L7.4415 5.2545L7.443 5.256L7.4415 5.25H16.632L16.6305 5.25525L19.5 10.1025L19.494 10.1032ZM9.642 10.4475L8.0145 13.203L12.0285 17.787L16.0507 13.1655L14.4592 10.4392L9.642 10.4475ZM7.5585 12.6825L8.8785 10.4482L5.607 10.4535L7.5585 12.6825ZM14.8507 9.798L18.5662 9.792L16.2338 5.886L12.5723 5.8935L14.8507 9.798ZM18.429 10.4325L15.2242 10.4377L16.509 12.639L18.429 10.4325ZM14.0858 9.7995L12.0675 6.3405L10.02 9.8055L14.0858 9.7995ZM7.7865 5.904L5.4615 9.81375L9.2565 9.807L11.5665 5.8965L7.7865 5.904Z", fill: color }));
}
exports["default"] = xas;
//# sourceMappingURL=xas.js.map